import { render, staticRenderFns } from "./GroupCreate.vue?vue&type=template&id=5465874b&scoped=true"
import script from "./GroupCreate.vue?vue&type=script&lang=js"
export * from "./GroupCreate.vue?vue&type=script&lang=js"
import style0 from "./GroupCreate.vue?vue&type=style&index=0&id=5465874b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465874b",
  null
  
)

export default component.exports